import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import { selectCurrent } from '../../../../../../redux/settings/selectors';
import { deepCopy } from '../../../../../../common/services/common.service';
import { useSelector } from 'react-redux';
import { settings } from '../../../../../../redux/settings/actions';
import UploadFiles from '../../../../../../models/UploadFile';
import PageLoader from '../../../../../../components/PageLoader';
import { selectNewsLettersCreatedItem, selectNewsLettersQueryItem } from '../../../../../../redux/news-letters/selector';
import { selectNewsLetterFilesQueryItem } from '../../../../../../redux/news-letters-files/selector';
import { newsletters } from '../../../../../../redux/news-letters/action';
import { newsletterFiles } from '../../../../../../redux/news-letters-files/action';
import NewsLetterComponent from '../components/news-letter.component';

let currentChange: any = {}
const ManagementNewsLetter = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const queryItems = useSelector(selectNewsLettersQueryItem)
  const NewsLetterFilequeryItems = useSelector(selectNewsLetterFilesQueryItem)
  const NewsLetterCreateItems = useSelector(selectNewsLettersCreatedItem)
  const [data, setData] = useState<boolean>(false)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedNewsLetter,
    setSelectedNewsLetter
  ] = useState<any>({})
  const [
    NewsLetterImageIndex,
    setNewsLetterImageIndex
  ] = useState<any>([])

  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);

  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }


  const fetchNewsLetterById = () => {
    dispatch(newsletters.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/news-letter/news-letters/query`, entity: 'newsletters', jsonData: {
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      dispatch(newsletterFiles.query({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/news-letter/news-letter-files/query-by-news-letter`, entity: 'newsletterFiles', jsonData: {

          Records: [
            {


              "NewsItemId": parmas?.id



            }
          ]

        }
      }))
    }).then(() => {

      setIsQuery(true)
    })




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedNewsLetter({ ...selectedNewsLetter, [field]: event });
  }

  useEffect(
    () => {
      if (parmas?.id > 0) {
        fetchNewsLetterById()
        setIsLoading(false)
      } else {
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedNewsLetter(queryItems?.result?.items)
        const newsLetterItemsData: any = NewsLetterFilequeryItems?.result?.items?.map((item: any) => {
          const itemData = {
            Id: item?.Id,
            NewsItemId: item?.NewsItemId,
            FileTypeId: item?.FileTypeId,
            FileMappingURL: item?.NewsItemFileURL
          }
          return itemData
        })
        if (newsLetterItemsData) {
          const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: newsLetterItemsData });
          setMediaFiles(localSelectedMedia)
        }
      }
    },
    [isQuery]
  )

  const deleteSelectedFile = async (Item: any, index: any) => {
    if (Item.Id === 0) {
      mediaFiles?.splice(
        index,
        1
      )
    }
    else {
      dispatch(newsletterFiles.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/news-letter/news-letter-files/delete`, entity: 'newsletterFiles', jsonData: {
        }
      })).then(() => {
        mediaFiles?.splice(
          index,
          1
        )
      })
    }
  }

  const getIsImageRecordDeletable = (idx: any) => {
    if (mediaFiles.length - 1 === idx) {
      return false
    }
    return true
  }

  useEffect(
    () => {

      if (data) {
        if (parmas?.id > 0) {
          mediaFiles?.splice(
            mediaFiles.length - 1,
            1
          )
          if (mediaFiles.length > 0) {
            const newsLetterFileData: any = mediaFiles?.map((item: any) => {
              const itemData = {
                Id: item?.Id,
                NewsItemId: parmas?.id,
                FileTypeId: item?.FileTypeId,
                NewsItemFileURL: item?.FileMappingURL
              }

              return itemData
            })
            dispatch(newsletterFiles.update({
              url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/news-letter/news-letter-files`, entity: 'newsletterFiles', jsonData: {

                Records: 
                  newsLetterFileData
              }
            }))
          }
          back()
        }
        else {
          mediaFiles?.splice(
            mediaFiles.length - 1,
            1
          )
          if (mediaFiles.length > 0) {
            const newsLetterFileData: any = mediaFiles?.map((item: any) => {
              const itemData = {
                Id: item?.Id,
                NewsItemId: NewsLetterCreateItems?.result[0],
                FileTypeId: item?.FileTypeId,
                NewsItemFileURL: item?.FileMappingURL
              }

              return itemData
            })
            dispatch(newsletterFiles.create({
              url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/news-letter/news-letter-files`, entity: 'newsletterFiles', jsonData: {

                Records: 
                  newsLetterFileData

              }
            }))
          }
          back()
        }
      }

    },
    [data]
  )
  const handleFormSubmit = async (event: any) => {

    event.preventDefault();
    if (parmas?.id > 0) {
      dispatch(newsletters.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/news-letter/news-letters`, entity: 'newsletters', jsonData: {

          Records: [



            selectedNewsLetter





          ]

        }
      })).then(() => {

        setData(true)

      })

    } else {
      dispatch(newsletters.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/news-letter/news-letters`, entity: 'newsletters', jsonData: {

          Records: [



            selectedNewsLetter





          ]

        }
      })).then(() => {

        setData(true)
      })
    }

  }

  const back = () => {
    navigate('/management/cms/news-letter/news-letters')
  }
  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      NewsItemId: parmas?.id,
      FileTypeId: 0,
      NewsItemFileURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setNewsLetterImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'Newsitem',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {

    mediaFiles[NewsLetterImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }

  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setCombinationInfo()
      }
    },
    [mediaFiles]
  )

  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
      />}
      {isLoading ? <PageLoader /> :
        <NewsLetterComponent
          handleInnerFormChange={handleInnerFormChange}
          handleFormSubmit={handleFormSubmit}
          back={back}
          selectedNewsLetter={selectedNewsLetter}
          mediaFiles={mediaFiles}
          handleFormItemChange={handleFormItemChange}
          changeImage={changeImage}
          getIsImageRecordDeletable={getIsImageRecordDeletable}
          deleteSelectedFile={deleteSelectedFile}
        />
      }

    </>
  )

}

export default ManagementNewsLetter;
